import styled from 'styled-components';
import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ThemeData } from '../../quant/quantData';
import { useModal } from '../../../context/ModalContext';
import { isLogin, userGradeType } from '../../../utils/auth';

const QuantBox = () => {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  return (
    <Section>
      <Container>
        <TitleSeciton>
          <Title>
            퀀트 분석 기반 테마 추천(宙)
            <MoreButton onClick={() => navigate('/quant')}>
              전체보기
              <img
                src="/assets/images/arrow/arrow-right-gray-small.svg"
                alt=""
              />
            </MoreButton>
          </Title>
          <PageDescription>
            <div>
              복잡한 설정 없이, 이미 검증된 빅데이터 전략으로 경매 물건을 추천
              받아보세요.
            </div>
            <div>
              설정할 필요 없이, 수십 년 축적된 데이터를 통해 가장 돈 되는 테마별
              포트폴리오를 제시합니다.
            </div>
          </PageDescription>
        </TitleSeciton>
        {ThemeData.map((item, index) => (
          <ThemeItem
            key={index}
            onClick={async () => {
              if (!isLogin()) {
                modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                return;
              }
              navigate('/quant/theme?indexes=' + index);
            }}
          >
            <Icon>
              <img src={item.image} alt="" />
            </Icon>
            <ItemContent>
              <ItemTitle>{item.name}</ItemTitle>
              <ItemDescription>{item.description}</ItemDescription>
            </ItemContent>
          </ThemeItem>
        ))}
      </Container>
    </Section>
    // <Box gap={24} style={{ padding: '32px 16px' }}>
    //   <Text
    //     color="#222222"
    //     size={18}
    //     weight={700}
    //     style={{ textAlign: 'start' }}
    //   >
    //     퀀트 분석 기반 테마 추천(宙)
    //   </Text>
    //   <Description_Box
    //     desc1="복잡한 설정 없이, 이미 검증된 빅데이터 전략으로 경매 물건을 추천 받아보세요."
    //     desc2="설정할 필요 없이, 수십 년 축적된 데이터를 통해 가장 돈 되는 테마별 포트폴리오를 제시합니다."
    //   />
    //   <ItemBox>
    //     {ThemeData.map((item, index) => (
    //       <Item
    //         key={index}
    //         onClick={async () => {
    //           if (!isLogin()) {
    //             modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
    //             return;
    //           }
    //           navigate('/quant/theme?indexes=' + index);
    //         }}
    //       >
    //         <TextBox>
    //           <ItemName>
    //             <span>{item.name}</span>
    //           </ItemName>
    //         </TextBox>
    //         <ItemImage
    //           src={item.image}
    //           alt=""
    //           style={{ width: '44px', height: '44px' }}
    //         />
    //       </Item>
    //     ))}
    //   </ItemBox>
    // </Box>
  );
};

export default QuantBox;

const Section = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 16px 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const Container = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 16px;
  background: #fff;
`;

const TitleSeciton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;
const MoreButton = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  color: #4e5968;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const PageDescription = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 16px;
  background: rgba(2, 32, 71, 0.05);

  color: #008aff;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;

  & > :last-child {
    color: #616161;
    font-size: 12px;
  }
`;

const ThemeItem = styled.div`
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 12px;
  &:active {
    background: rgba(2, 32, 71, 0.05);
  }
`;

const Icon = styled.div`
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  background: #f3f4f6;

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`;

const ItemTitle = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 13px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.26px;
`;

const ItemDescription = styled.div`
  color: #6b7684;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
